let _session = "auto";   // "auto" | "paper" | "live"
let _mdMode = "auto";    // "auto" | "realtime" | "delayed"

/**
 * Build a URL path with global query params appended.
 * Accepts absolute or relative paths; returns a relative path (for CRA proxy).
 */
export function buildUrl(path, extra = {}) {
  const base = typeof path === "string" ? path : String(path || "");
  const url = new URL(base, window.location.origin);
  const p = new URLSearchParams(url.search);

  if (_session && _session !== "auto") p.set("session", _session);
  if (_mdMode && _mdMode !== "auto") p.set("md_mode", _mdMode);

  Object.entries(extra).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
  });

  const qs = p.toString();
  return url.pathname + (qs ? `?${qs}` : "");
}

export function setSession(session) {
  _session = session || "auto";
}

export function setMdMode(mdMode) {
  _mdMode = mdMode || "auto";
}

export function getConnState() {
  return { session: _session, mdMode: _mdMode };
}